export const useTouchDevice = () => {
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  return { isTouch }
}
